


















import { NotificationType } from "@/types/notification";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BaseCard extends Vue {
  mounted() {
    if (this.help) {
      const help: any = this.$refs.help;

      if (help.scrollHeight > help.clientHeight) {
        this.showReadMoreButton = true;
      }
    }
  }

  @Prop({ required: false, default: false })
  grow!: boolean;

  @Prop({ required: false, default: false })
  dark!: boolean;

  @Prop({ required: false, default: false })
  help!: boolean;

  @Prop({ required: false, default: false })
  isDisabled!: boolean;

  @Prop({ required: false, default: false })
  isButton!: boolean;

  @Prop({ required: false, default: NotificationType.DEFAULT })
  issueType!: NotificationType;

  showReadMore = false;

  showReadMoreButton = false;

  get growClass() {
    return this.grow ? "grow" : "";
  }

  get darkClass() {
    return this.dark ? "dark" : "";
  }

  get helpClass() {
    return this.help ? "help" : "";
  }

  get helpOpenClass() {
    return this.showReadMore ? "open" : "";
  }

  get readMoreButtonClass() {
    return this.showReadMoreButton ? "show" : "";
  }

  get readMoreTitle() {
    return this.showReadMore ? "Read Less" : "Read More";
  }

  get disabledClass() {
    return this.isDisabled ? "disabled" : "";
  }

  get buttonClass() {
    return this.isButton ? "is-button" : "";
  }

  toggleReadMore() {
    this.showReadMore = !this.showReadMore;
  }
}
